import { MessageCircle } from 'lucide-react';
import { SCHOOL } from '@/data/content';

const WhatsAppButton = () => (
  <a
    data-testid="whatsapp-button"
    href={`https://wa.me/${SCHOOL.whatsapp}?text=${encodeURIComponent('Namaste! I want to enquire about admission at Ideal Public School.')}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 right-6 z-40 group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-navy/20 transition-transform group-hover:scale-110">
      <MessageCircle className="h-6 w-6 fill-white" />
    </span>
  </a>
);

export default WhatsAppButton;
